export const LifeAtCalendarEventColors = {
    blue: {
        background: "#D5E3F9",
        text: "#2E4E8A",
    },
    grey: {
        background: "#E4E4E4",
        text: "#4E4E4E",
    },
};

export const IntegrationCalendarColorMap: { [key: string]: { background: string; text: string } } = {
    // outlook default calendar colors
    "#a4262c": {
        background: "#FFC3C3",
        text: "#642C26",
    },
    "#d13438": {
        background: "#FFDED7",
        text: "#633C36",
    },
    "#f7630c": {
        background: "#FBDEC4",
        text: "#7F2206",
    },
    "#fde300": {
        background: "#FDEDC3",
        text: "#554211",
    },
    "#8e562e": {
        background: "#ECDFDF",
        text: "#534242",
    },
    "#00cc6a": {
        background: "#DBFCF0",
        text: "#255B55",
    },
    "#107c10": {
        background: "#D4F4DB",
        text: "#075A15",
    },
    "#038387": {
        background: "#E6FBEE",
        text: "#255B3A",
    },
    "#0099bc": {
        background: "#DAEAF9",
        text: "#3C5478",
    },
    "#0078d4": {
        background: "#C3D6E7",
        text: "#0B3456",
    },
    "#0027b4": {
        background: "#E0E5FF",
        text: "#2F3977",
    },
    "#5c2e91": {
        background: "#D8DCFF",
        text: "#384079",
    },
    "#b146c2": {
        background: "#EACDF5",
        text: "#4A115F",
    },
    "#bf0077": {
        background: "#E8C6E4",
        text: "#572170",
    },
    "#69797e": {
        background: "#DEDEDE",
        text: "#363636",
    },

    // google default calendar colors
    "#ac725e": {
        background: "#FBDEC4",
        text: "#7F2206",
    },
    "#d06b64": {
        background: "#FFDED7",
        text: "#633C36",
    },
    "#f83a22": {
        background: "#FFC3C3",
        text: "#642C26",
    },
    "#ff7537": {
        background: "#FBDEC4",
        text: "#7F2206",
    },
    "#fa573c": {
        background: "#FBD7CB",
        text: "#633C36",
    },
    "#ffad46": {
        background: "#FDEDC3",
        text: "#554211",
    },
    "#42d692": {
        background: "#DBFCF0",
        text: "#255B55",
    },
    "#16a765": {
        background: "#D4F4DB",
        text: "#075A15",
    },
    "#7bd148": {
        background: "#E6FBEE",
        text: "#255B3A",
    },
    "#b3dc6c": {
        background: "#E5F5D9",
        text: "#46602C",
    },
    "#fbe983": {
        background: "#FDFBC4",
        text: "#554211",
    },
    "#fad165": {
        background: "#FDEDC3",
        text: "#554211",
    },
    "#92e1c0": {
        background: "#E6FBEE",
        text: "#255B3A",
    },
    "#9fc6e7": {
        background: "#DAEAF9",
        text: "#3C5478",
    },
    "#4986e7": {
        background: "#C3D6E7",
        text: "#0B3456",
    },
    "#9a9cff": {
        background: "#E0E5FF",
        text: "#2F3977",
    },
    "#b99aff": {
        background: "#D8DCFF",
        text: "#384079",
    },
    "#c2c2c2": {
        background: "#DEDEDE",
        text: "#363636",
    },
    "#cabdbf": {
        background: "#ECDFDF",
        text: "#534242",
    },
    "#cca6ac": {
        background: "#EBD6D6",
        text: "#644A4A",
    },
    "#f691b2": {
        background: "#FFE3F4",
        text: "#561E4A",
    },
    "#cd74e6": {
        background: "#F4C9ED",
        text: "#542155",
    },
    "#a47ae2": {
        background: "#E8C6E4",
        text: "#572170",
    },
    "#9fe1e7": {
        background: "#C3D6E7",
        text: "#0B3456",
    },
};

export default LifeAtCalendarEventColors;
